export enum PieMenuIcons
{
    DEL = 'ic_delete',
    FLP = 'ic_flip',
    LCK = 'ic_lock',
    UNL = 'ic_unlock',
    MAG = 'ic_magnifying_glass',
    MOV = 'ic_move_to_player',
    SHF = 'ic_shuffle',
    ALL = 'ic_to_all_players',
    HND = 'ic_to_hand',
    TBL = 'ic_to_table',
}
